/// <reference path="../_all.ts" />


module menuEditor {
  'use strict';

	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class MenuEditorCtrl {


    // $inject annotation.
    // it provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // see http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$mdDialog',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IMenuEditorScope,
      private $mdDialog: ng.material.IDialogService
    ) {

      $scope.vm = this;
      $scope.customFullscreen = false;
    }

    showTabDialog(ev): void {
      this.$mdDialog.show({
        controller: MenuEditorDetailCtrl,
        templateUrl: 'menueditor/MenuEditorDialog',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false
      });
    }
  }
}